import { Injectable } from '@angular/core';
import { WizardStepResolve } from '../../shared/wizard/wizard-step-resolve.service';
import { RegistrationStepsService } from './registration-steps.service';

@Injectable()
export class RegistrationStepsResolve extends WizardStepResolve {
	constructor(wizardService: RegistrationStepsService) {
		super(wizardService);
	}
}